import { Component, computed, OnDestroy, OnInit, signal } from '@angular/core';
import { TaxonomyBannerService } from '@portal/app/shared/components/taxonomy-banner/taxonomy-banner.service';
import { ToastMessageOptions } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'portal-taxonomy-banner',
  templateUrl: './taxonomy-banner.component.html',
  styleUrl: './taxonomy-banner.component.scss',
  standalone: false
})
export class TaxonomyBannerComponent implements OnInit, OnDestroy {
  public messages = signal<ToastMessageOptions[]>([]);
  public messagesCount = computed(() => this.messages().length);
  public aiMessages = signal<ToastMessageOptions[]>([]);
  public aiMessagesCount = computed(() => this.aiMessages().length);

  private destroy$ = new Subject<void>();

  constructor(private readonly taxonomyBannerService: TaxonomyBannerService) {}

  ngOnInit(): void {
    this.taxonomyBannerService.getHeroMetrics();
    this.taxonomyBannerService.heroMetrics$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.messages.set(this.taxonomyBannerService.getUnmappedMessages());
        this.aiMessages.set(
          this.taxonomyBannerService.getAiRecommendedMessages()
        );
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
